export const machineLearningOptions = [
  { id: 0, name: 'No' },
  { id: 1, name: 'Yes' },
];